import { FormConfig } from '@lbcamden/lib-react';
import { z } from 'zod';

import { personFieldDisplayValues } from '~/client/config/display-values/people';
import { sanitiseNumberString } from '~/client/utils/string';
import { contactDetailsFormSchema } from '~/common/schemas/people';

export type ContactDetailsFormValues = z.infer<typeof contactDetailsFormSchema>;

export const contactDetailsFormConfig: FormConfig<ContactDetailsFormValues> = {
  fieldDisplayValues: personFieldDisplayValues,
  fieldConfigs: {
    mobileNumbers: {
      sanitiseFn: sanitiseNumberString,
    },
    smsOnlyNumbers: {
      sanitiseFn: sanitiseNumberString,
    },
    otherPhoneNumbers: {
      sanitiseFn: sanitiseNumberString,
    },
  },
};
